import { render, staticRenderFns } from "./EditarSubunidades.vue?vue&type=template&id=6bd84b8a&scoped=true"
import script from "./EditarSubunidades.vue?vue&type=script&lang=js"
export * from "./EditarSubunidades.vue?vue&type=script&lang=js"
import style0 from "./EditarSubunidades.vue?vue&type=style&index=0&id=6bd84b8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd84b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd84b8a')) {
      api.createRecord('6bd84b8a', component.options)
    } else {
      api.reload('6bd84b8a', component.options)
    }
    module.hot.accept("./EditarSubunidades.vue?vue&type=template&id=6bd84b8a&scoped=true", function () {
      api.rerender('6bd84b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/EditarSubunidades.vue"
export default component.exports